import type { ServiceId } from "../types/domain";
import { parkingAmountLabel, parkingPaymentInfo } from "./parkingPayment";

export type NightAiIconId = "wash" | "charge" | "park" | "package" | "fuel" | "history" | "accident" | "standby";

export interface NightAiCardContent {
  icon: NightAiIconId;
  collapsedTitle: string;
  collapsedDescription: string;
  expandedTitle: string;
  expandedDescription: string;
  primaryAction: string;
  secondaryAction: string;
}

// Existing main-card copy is the editable layer. Geometry, wallpaper, clock, and click behavior stay in shared components.
export const nightAiCardContent: Record<ServiceId, NightAiCardContent> = {
  parcel: {
    icon: "package",
    collapsedTitle: "快递待取",
    collapsedDescription: "你有2件待取快递",
    expandedTitle: "快递待取",
    expandedDescription: "你有2件待取快递",
    primaryAction: "查看详情",
    secondaryAction: "稍后提醒"
  },
  carwash: {
    icon: "wash",
    collapsedTitle: "顺路洗车",
    collapsedDescription: "未来几天天气较好，29.9元",
    expandedTitle: "顺路洗车",
    expandedDescription: "未来几天天气较好，建议顺路洗车，到店29.9元，绕路约4分钟",
    primaryAction: "顺路洗车",
    secondaryAction: "取消"
  },
  charging: {
    icon: "charge",
    collapsedTitle: "目的地补能",
    collapsedDescription: "目的地附近有充电站，1.2元/度",
    expandedTitle: "目的地补能",
    expandedDescription: "目的地附近有充电站，电价1.2元/度，停车10元/小时",
    primaryAction: "目的地补能",
    secondaryAction: "取消"
  },
  parking: {
    icon: "park",
    collapsedTitle: "停车助手",
    collapsedDescription: `待支付${parkingAmountLabel()}，已停${parkingPaymentInfo.duration}`,
    expandedTitle: "停车助手",
    expandedDescription: `${parkingPaymentInfo.lotName}，${parkingPaymentInfo.plateNumber}已停${parkingPaymentInfo.duration}，待支付${parkingAmountLabel()}`,
    primaryAction: "去支付",
    secondaryAction: "取消"
  },
  refuel: {
    icon: "fuel",
    collapsedTitle: "顺路加油",
    collapsedDescription: "低油量，已匹配顺路站点",
    expandedTitle: "顺路加油",
    expandedDescription: "建议按当前行程补充适量油量，先导航到站再生成核销授权码",
    primaryAction: "导航加油",
    secondaryAction: "取消"
  },
  collision: {
    icon: "accident",
    collapsedTitle: "可能发生了事故",
    collapsedDescription: "自动触发了紧急录制，是否需要事故引导",
    expandedTitle: "可能发生了事故",
    expandedDescription: "自动触发了紧急录制，是否需要事故引导",
    primaryAction: "事故引导",
    secondaryAction: "取消"
  }
};

export const idleNightAiCardContent: NightAiCardContent = {
  icon: "standby",
  collapsedTitle: "AI智能备车",
  collapsedDescription: "已完成备车任务",
  expandedTitle: "AI智能备车",
  expandedDescription: "已完成备车任务",
  primaryAction: "知道了",
  secondaryAction: "取消"
};

export function getNightAiCardContent(serviceId: ServiceId) {
  return nightAiCardContent[serviceId];
}
